import { AbstractDimension } from '@orus.eu/dimensions'
import { type FrMrpaxeQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

/**
 * The tariff refuses no risk the exclusions let through, and a commune its zone table does not know is priced on the
 * zones around it, so pricing cannot fail.
 */
export type FrMrpaxeQuoteFailure = never
export type FrMrpaxeQuoteResult = Result<FrMrpaxeQuote, FrMrpaxeQuoteFailure>

export class FrMrpaxeQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrMrpaxeQuoteResult> {
  override formatToString(value: FrMrpaxeQuoteResult): string {
    if (value.type === 'failure') return 'NULL'
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frMrpaxeQuoteDimension = new FrMrpaxeQuoteDimension({
  name: 'frMrpaxeQuote',
  displayKeys: { name: 'dimension_name_fr_mrpaxe_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
